// Part numbers are shown in upper case everywhere, whatever casing they were
// typed, scanned or stored with. Display only: the stored value is untouched,
// and matching elsewhere already ignores case.
export const displayPartNumber = (value: unknown): string => {
  if (value == null) return '';
  if (Array.isArray(value)) {
    return value.map((entry) => displayPartNumber(entry)).filter(Boolean).join(', ');
  }
  return String(value).trim().toUpperCase();
};
